<!--
  描述：拖放地图组件，默认尺寸是 500 * 300

  接收属性参数：
    lat: 纬度
    lng: 经度

  自定义事件：
    drag: 拖放完成事件

  示例：
    <mapDrag @drag="dragMap" lat="22.574405" lng="114.095388"></mapDrag>
-->
<template>
  <div class="m-map">
    <div class="search" v-if="placeSearch">
      <input type="text" placeholder="请输入关键字" v-model="searchKey">
      <button type="button" @click="handleSearch">搜索</button>
      <div id="js-result" v-show="searchKey" class="result"></div>
    </div>
    <div id="js-container" class="map">正在加载数据 ...</div>
  </div>
</template>

<script>
import  'echarts/extension/bmap/bmap'
export default {
  props: ['lat', 'lng'],
  data () {
    return {
      searchKey: '',
      placeSearch: null,
      dragStatus: false,
      allEquipmentPointsList:[],
      equipinfoList:[]
    }
  },
  watch: {
    searchKey () {
      if (this.searchKey === '') {
        this.placeSearch.clear()
      }
    }
  },
  mounted(){
    this.loadEquipPoints();
  },
  methods: {
    // 搜索
    handleSearch () {
      if (this.searchKey) {
        this.placeSearch.search(this.searchKey)
      }
    },
    // 实例化地图
    initMap () {
      //let map1 = this.$echarts.init(document.getElementById('js-container'))
      var map = new BMap.Map("js-container");
      map.centerAndZoom(new BMap.Point(120.000,32.000),6);
      map.enableScrollWheelZoom();
      if(document.createElement('canvas').getContext){
        var points=[];
        for (let i = 0; i < this.allEquipmentPointsList.length; i++) {
          var point=new BMap.Point(this.allEquipmentPointsList[i].lng, this.allEquipmentPointsList[i].lat);
          point.id = this.allEquipmentPointsList[i].id;
          //points.push(new BMap.Point(this.allEquipmentPointsList[i].lng,this.allEquipmentPointsList[i].lat),this.allEquipmentPointsList[i].id)
          points.push(point);
        }
        var options = {
          size: BMAP_POINT_SIZE_NORMAL,
          shape: BMAP_POINT_SHAPE_WATERDROP,
          color:'#3a8ee6'
        }
        var pointCollection = new BMap.PointCollection(points,options);
        let that = this
        pointCollection.addEventListener('click',function(e){
          var p=e.point;
          that.loadEquipInfoList(p.id).then(res=>{
            //alert('单击的点为：'+ e.point.lng +','+ e.point.lat);
            var point = new BMap.Point(e.point.lng, e.point.lat);
            var opts = {
              width: 200,     // 信息窗口宽度
              height: 150,     // 信息窗口高度
              title: "设备信息", // 信息窗口标题
              enableMessage: false//设置允许信息窗发送短息
            };
            var infowindow = new BMap.InfoWindow('设备名称：'+ that.equipinfoList.name + '<br> 设备编号：'+ that.equipinfoList.number,opts);
            map.openInfoWindow(infowindow, point);
          });

        })
        map.addOverlay(pointCollection);
      }else{
        alert('请在chrome/Safari/IE8+以上浏览器查看')
      }
    },
    //加载获取所有设备的点位信息
    loadEquipPoints(){
      let that = this;
      this.$httpservice.get("api/Analysis/AllEquipmentPoints").then(
        function (data) {
          if(data.body.code=="200"){
            that.allEquipmentPointsList = data.body.data;
            that.initMap()
            }else{
              that.$message({
                message: data.body.msg,
                type: 'warning'
              });
            }
          },
          function (data) {
            let statusCode = data.status;
              that.$message({
                message: that.$t('queryFailedStatusCode')+statusCode,
                type: 'warning'
            });
          }
        );
    },
    //获取设备详情信息
    loadEquipInfoList(id){
      let that = this;
      return this.$httpservice.get("api/Equipment/Get",{id:id}).then(
        function (data) {
          if(data.body.code=="200"){
            that.equipinfoList = data.body.data;
          }else{
            that.$message({
              message: data.body.msg,
              type: 'danger'
            });
          }
        },
        function (data) {
          let statusCode = data.status;
          that.$message({
            message: that.$t('queryFailedStatusCode')+statusCode,
            type: 'warning'
          });
        }
      );
    },
  }
}

</script>

<style lang="css">
.m-map{ height: 100%; position: relative; }
.m-map .map{ width: 100%; height: 100%; }
.m-map .search{ position: absolute; top: 10px; left: 10px; width: 285px; z-index: 1; }
.m-map .search input{ width: 180px; border: 1px solid #ccc; line-height: 20px; padding: 5px; outline: none; }
.m-map .search button{ line-height: 26px; background: #fff; border: 1px solid #ccc; width: 50px; text-align: center; }
.m-map .result{ max-height: 300px; overflow: auto; margin-top: 10px; }
</style>



// WEBPACK FOOTER //
// src/components/mapDrag.vue